export default function log(level, ...args) {
  // When running in development, Vite set import.meta.env.DEV to true.
  if (import.meta.env.DEV) {
    if (level === 'error') {
      console.error(...args)
    } else if (level === 'warn') {
      console.warn(...args)
    } else {
      // info
      console.log(...args)
    }
  }
}
